/**
 * Default implementation of low-level transport. Each low-level transport should implement following methods:
 * <ul>
 *     <li>send(kind : String, endpoint : String, method : String, params : *[]) : Promise<Object> -
 *     performs a network query.
 *     <li>isSessionExpiredReason(details : Object) - checks if query's failure object denotes a "session expired" failure.
 * </ul>
 */
define([], ()=> {
    function encodeBasicAuth(login, password) {
        return window.btoa(`${login}:${password}`);
    }

    /** Searches for the authentication header. */
    function findAuthHeader(settings) {
        const authOptions = settings.auth;
        if (authOptions === null) {
            return null;
        }
        if (typeof authOptions === 'string') {
            return authOptions;
        }

        switch (authOptions.kind) {
            case 'basic' :
                return `Basic ${encodeBasicAuth(authOptions.username, authOptions.password)}`;
            default :
                return null;
        }
    }

    return ['$http', '$q', 'httpSettings', 'LocaleService', ($http, $q, httpSettings, locale)=> {
        let requestCode = 0;
        const serviceBaseURLs = httpSettings.serviceBaseURLs;

        const baseHeaders = {
            'Content-Type': 'application/json; charset=utf-8'
        };

        const authValue = findAuthHeader(httpSettings);
        // if (authValue) {
        //     baseHeaders.Authorization = authValue;
        // }

        return {
            send: (xCenterType, serviceEndpoint, method, params)=> {
                const headers = angular.copy(baseHeaders);
                headers['Accept-Language'] = locale.getCurrentLocale();
                // UserToken should be portal user only; this usertoken will be used
                // for tracking the transactions made from QB portal
                headers['UserToken'] = "pu";
                const callStart = new Date().getTime();
                requestCode++;
                return $http({
                    method: 'POST',
                    url: serviceBaseURLs[xCenterType] + serviceEndpoint,
                    data: {
                        method,
                        params,
                        'jsonrpc': '2.0'
                    },
                    headers,
                    timeout: httpSettings.timeout
                })
                    .then((response)=> {
                            return response.data.result;
                        }, (error)=> {
                            console.error(error);
                            const callTime = new Date().getTime() - callStart;
                            return $q.reject({
                                baseError: error,
                                isTimeout: (error.status === 0) && callTime < httpSettings.timeout
                            });
                        }
                    );
            },

            isSessionExpiredReason: (reason)=> {
                return reason.isTimeout === true;
            }
        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/transport/TransportDefaultService.js
 **/